import { HTMLAttributes } from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { SanityImage } from "../sanity-image";
import { SanityImageSource } from "@sanity/image-url/lib/types/types";
import { hasProperty } from "@/lib/utils";

interface TestimonialProps extends HTMLAttributes<HTMLDivElement> {
  name: string;
  role: string;
  image: SanityImageSource;
  quote: string;
  blurHash?: string;
}
export function Testimonial({
  name,
  role,
  image,
  quote,
  className,
  blurHash,
  ...props
}: TestimonialProps) {
  return (
    <div
      {...props}
      className={`relative flex flex-col gap-4 ${className} bg-white shadow-[0px_0px_10px_0px_#0000001A] max-w-[600px] lg:max-w-2xl  p-16 rounded-3xl pt-20 basis-1`}
    >
      {image && hasProperty(image, "asset") && image.asset ? (
        <div className="w-28 absolute -top-14 left-1/2 -translate-x-1/2">
          <AspectRatio ratio={1}>
            <SanityImage
              src={image}
              blurDataURL={blurHash}
              alt="event"
              fill
              quality={60}
              className="object-cover rounded-full cursor-pointer border-2 border-primary-50"
            />
          </AspectRatio>
        </div>
      ) : (
        <div className="w-28 absolute -top-14 left-1/2 -translate-x-1/2 rounded-full bg-neutral-300 aspect-square flex items-center justify-center">
          <span className="text-3xl">
            {name
              .split(" ")
              .map((name) => name.slice(0, 1))
              .join("")
              .toUpperCase()}
          </span>
        </div>
      )}
      <div className="flex w-full items-center flex-col gap-1">
        <h3 className="font-medium text-lg lg:text-2xl">{name}</h3>
        <h4 className="text-sm lg:text-base">{role}</h4>
      </div>
      <p className="text-xs sm:text-sm lg:text-lg line-clamp-[8]  text-center leading-loose font-light text-primary-text-400">
        {quote}
      </p>
    </div>
  );
}
